import {
  Locale,
  DistanceTranslations,
  TextTranslations,
  OtherTranslations,
} from "./types";

export const distanceTranslations: Record<Locale, DistanceTranslations> = {
  en: {
    distanceUnit: { singular: "Mile", plural: "Miles" },
    any: "Any",
    radius: "Radius:",
    everywhere: "Everywhere",
  },
  pl: {
    distanceUnit: { singular: "Mila", plural: "Mil" },
    any: "Dowolna",
    radius: "Promień:",
    everywhere: "Wszędzie",
  },
  es: {
    distanceUnit: { singular: "Milla", plural: "Millas" },
    any: "Cualquiera",
    radius: "Radio:",
    everywhere: "En todas partes",
  },
  am: {
    distanceUnit: { singular: "ማይል", plural: "ማይሎች" },
    any: "ማናቸውም",
    radius: "ራዲየስ:",
    everywhere: "በሁሉም ቦታ",
  },
  ar: {
    distanceUnit: { singular: "ميل", plural: "أميال" },
    any: "أي",
    radius: "نصف القطر:",
    everywhere: "في كل مكان",
  },
  de: {
    distanceUnit: { singular: "Meile", plural: "Meilen" },
    any: "Beliebig",
    radius: "Radius:",
    everywhere: "Überall",
  },
  fa: {
    distanceUnit: { singular: "مایل", plural: "مایل" },
    any: "هر",
    radius: "شعاع:",
    everywhere: "همه جا",
  },
  fi: {
    distanceUnit: { singular: "Maili", plural: "Mailia" },
    any: "Mikä tahansa",
    radius: "Säde:",
    everywhere: "Kaikkialla",
  },
  fil: {
    distanceUnit: { singular: "Milya", plural: "Milya" },
    any: "Anuman",
    radius: "Radius:",
    everywhere: "Saanman",
  },
  ff: {
    distanceUnit: { singular: "Mayl", plural: "Mayle" },
    any: "Fow",
    radius: "Radius:",
    everywhere: "Fow nokku",
  },
  fr: {
    distanceUnit: { singular: "Mile", plural: "Miles" },
    any: "N'importe quelle",
    radius: "Rayon:",
    everywhere: "Partout",
  },
  hi: {
    distanceUnit: { singular: "मील", plural: "मील" },
    any: "कोई भी",
    radius: "त्रिज्या:",
    everywhere: "हर जगह",
  },
  hr: {
    distanceUnit: { singular: "Milja", plural: "Milje" },
    any: "Bilo koja",
    radius: "Radijus:",
    everywhere: "Svugdje",
  },
  ht: {
    distanceUnit: { singular: "Mil", plural: "Mil" },
    any: "Nenpòt",
    radius: "Rayon:",
    everywhere: "Toupatou",
  },
  ko: {
    distanceUnit: { singular: "마일", plural: "마일" },
    any: "모두",
    radius: "반경:",
    everywhere: "모든 곳",
  },
  km: {
    distanceUnit: { singular: "ម៉ាយ", plural: "ម៉ាយ" },
    any: "ណាមួយ",
    radius: "កាំ:",
    everywhere: "គ្រប់ទីកន្លែង",
  },
  lo: {
    distanceUnit: { singular: "ໄມລ໌", plural: "ໄມລ໌" },
    any: "ໃດກໍໄດ້",
    radius: "ລັດສະໝີ:",
    everywhere: "ທຸກບ່ອນ",
  },
  mww: {
    distanceUnit: { singular: "Mais", plural: "Mais" },
    any: "Ib yam",
    radius: "Vojvoog:",
    everywhere: "Txhua qhov chaw",
  },
  ne: {
    distanceUnit: { singular: "माइल", plural: "माइल" },
    any: "कुनै पनि",
    radius: "त्रिज्या:",
    everywhere: "जताततै",
  },
  om: {
    distanceUnit: { singular: "Maayilii", plural: "Maayilii" },
    any: "Kamuu iyyuu",
    radius: "Radius:",
    everywhere: "Bakka hundumaa",
  },
  or: {
    distanceUnit: { singular: "ମାଇଲ୍", plural: "ମାଇଲ୍" },
    any: "ଯେକୌଣସି",
    radius: "ବ୍ୟାସାର୍ଦ୍ଧ:",
    everywhere: "ସବୁଠି",
  },
  ps: {
    distanceUnit: { singular: "میل", plural: "میله" },
    any: "هر",
    radius: "وړانګه:",
    everywhere: "هر ځای کې",
  },
  prs: {
    distanceUnit: { singular: "میل", plural: "میل" },
    any: "هر",
    radius: "شعاع:",
    everywhere: "همه جا",
  },
  pt: {
    distanceUnit: { singular: "Milha", plural: "Milhas" },
    any: "Qualquer",
    radius: "Raio:",
    everywhere: "Em todos os lugares",
  },
  ru: {
    distanceUnit: { singular: "Миля", plural: "Миль" },
    any: "Любой",
    radius: "Радиус:",
    everywhere: "Везде",
  },
  so: {
    distanceUnit: { singular: "Mayl", plural: "Mayl" },
    any: "Wax kasta",
    radius: "Radius:",
    everywhere: "Meel kasta",
  },
  sw: {
    distanceUnit: { singular: "Maili", plural: "Maili" },
    any: "Yoyote",
    radius: "Eneo:",
    everywhere: "Kila mahali",
  },
  uk: {
    distanceUnit: { singular: "Миля", plural: "Милі" },
    any: "Будь-яка",
    radius: "Радіус:",
    everywhere: "Скрізь",
  },
  vi: {
    distanceUnit: { singular: "Dặm", plural: "Dặm" },
    any: "Bất kỳ",
    radius: "Bán kính:",
    everywhere: "Mọi nơi",
  },
  yue: {
    distanceUnit: { singular: "英里", plural: "英里" },
    any: "任何",
    radius: "半徑:",
    everywhere: "所有地方",
  },
  "zh-Hans": {
    distanceUnit: { singular: "英里", plural: "英里" },
    any: "任何",
    radius: "半径:",
    everywhere: "所有地方",
  },
  "zh-Hant": {
    distanceUnit: { singular: "英里", plural: "英里" },
    any: "任何",
    radius: "半徑:",
    everywhere: "所有地方",
  },
};

export const textTranslations: Record<Locale, TextTranslations> = {
  en: {
    title: "How can we help?",
    queryInputPlaceholder: "Search for services...",
    locationInputPlaceholder: "Enter your location...",
    noResultsFallbackText: "No results found. Try a different search.",
  },
  pl: {
    title: "Jak możemy pomóc?",
    queryInputPlaceholder: "Wyszukaj usługi...",
    locationInputPlaceholder: "Wprowadź swoją lokalizację...",
    noResultsFallbackText:
      "Nie znaleziono wyników. Spróbuj innego wyszukiwania.",
  },
  es: {
    title: "¿Cómo podemos ayudarte?",
    queryInputPlaceholder: "Buscar servicios...",
    locationInputPlaceholder: "Ingresa tu ubicación...",
    noResultsFallbackText:
      "No se encontraron resultados. Intenta con otra búsqueda.",
  },
  am: {
    title: "እንዴት ልንረዳዎት እንችላለን?",
    queryInputPlaceholder: "አገልግሎቶችን ይፈልጉ...",
    locationInputPlaceholder: "የእርስዎን አካባቢ ያስገቡ...",
    noResultsFallbackText: "ምንም ውጤት አልተገኘም። የተለየ ፍለጋ ይሞክሩ።",
  },
  ar: {
    title: "كيف يمكننا مساعدتك؟",
    queryInputPlaceholder: "ابحث عن الخدمات...",
    locationInputPlaceholder: "أدخل موقعك...",
    noResultsFallbackText: "لم يتم العثور على نتائج. جرب بحثًا مختلفًا.",
  },
  de: {
    title: "Wie können wir helfen?",
    queryInputPlaceholder: "Nach Diensten suchen...",
    locationInputPlaceholder: "Geben Sie Ihren Standort ein...",
    noResultsFallbackText:
      "Keine Ergebnisse gefunden. Versuchen Sie eine andere Suche.",
  },
  fa: {
    title: "چگونه می‌توانیم کمک کنیم؟",
    queryInputPlaceholder: "جستجوی خدمات...",
    locationInputPlaceholder: "موقعیت خود را وارد کنید...",
    noResultsFallbackText: "نتیجه‌ای یافت نشد. جستجوی دیگری امتحان کنید.",
  },
  fi: {
    title: "Kuinka voimme auttaa?",
    queryInputPlaceholder: "Etsi palveluita...",
    locationInputPlaceholder: "Syötä sijaintisi...",
    noResultsFallbackText: "Tuloksia ei löytynyt. Kokeile erilaista hakua.",
  },
  fil: {
    title: "Paano kami makakatulong?",
    queryInputPlaceholder: "Maghanap ng mga serbisyo...",
    locationInputPlaceholder: "Ilagay ang iyong lokasyon...",
    noResultsFallbackText:
      "Walang nahanap na resulta. Subukan ang ibang paghahanap.",
  },
  ff: {
    title: "No mbaɗnoo min wallitde?",
    queryInputPlaceholder: "Yiylo carwe...",
    locationInputPlaceholder: "Naatnu nokkuure maa...",
    noResultsFallbackText: "Alaa ko keɓii. Eto yiylotaare woɗɗere.",
  },
  fr: {
    title: "Comment pouvons-nous vous aider?",
    queryInputPlaceholder: "Rechercher des services...",
    locationInputPlaceholder: "Entrez votre emplacement...",
    noResultsFallbackText:
      "Aucun résultat trouvé. Essayez une recherche différente.",
  },
  hi: {
    title: "हम कैसे मदद कर सकते हैं?",
    queryInputPlaceholder: "सेवाओं की खोज करें...",
    locationInputPlaceholder: "अपना स्थान दर्ज करें...",
    noResultsFallbackText: "कोई परिणाम नहीं मिला। कोई अलग खोज आज़माएं।",
  },
  hr: {
    title: "Kako možemo pomoći?",
    queryInputPlaceholder: "Pretraži usluge...",
    locationInputPlaceholder: "Unesite svoju lokaciju...",
    noResultsFallbackText: "Nema rezultata. Pokušajte s drugom pretragom.",
  },
  ht: {
    title: "Kijan nou ka ede?",
    queryInputPlaceholder: "Chèche sèvis yo...",
    locationInputPlaceholder: "Antre kote w ye...",
    noResultsFallbackText: "Pa gen rezilta. Eseye yon lòt rechèch.",
  },
  ko: {
    title: "어떻게 도와드릴까요?",
    queryInputPlaceholder: "서비스 검색...",
    locationInputPlaceholder: "위치를 입력하세요...",
    noResultsFallbackText: "결과를 찾을 수 없습니다. 다른 검색을 시도하세요.",
  },
  km: {
    title: "តើយើងអាចជួយអ្វីបាន?",
    queryInputPlaceholder: "ស្វែងរកសេវាកម្ម...",
    locationInputPlaceholder: "បញ្ចូលទីតាំងរបស់អ្នក...",
    noResultsFallbackText: "រកមិនឃើញលទ្ធផល។ សូមព្យាយាមស្វែងរកផ្សេង។",
  },
  lo: {
    title: "ພວກເຮົາສາມາດຊ່ວຍໄດ້ແນວໃດ?",
    queryInputPlaceholder: "ຄົ້ນຫາບໍລິການ...",
    locationInputPlaceholder: "ໃສ່ສະຖານທີ່ຂອງທ່ານ...",
    noResultsFallbackText: "ບໍ່ພົບຜົນໄດ້ຮັບ. ລອງຄົ້ນຫາອື່ນ.",
  },
  mww: {
    title: "Peb pab tau li cas?",
    queryInputPlaceholder: "Nrhiav kev pab...",
    locationInputPlaceholder: "Sau koj qhov chaw nyob...",
    noResultsFallbackText: "Tsis pom qhov tshwm sim. Sim nrhiav lwm yam.",
  },
  ne: {
    title: "हामी कसरी मद्दत गर्न सक्छौं?",
    queryInputPlaceholder: "सेवाहरू खोज्नुहोस्...",
    locationInputPlaceholder: "आफ्नो स्थान प्रविष्ट गर्नुहोस्...",
    noResultsFallbackText: "कुनै परिणाम फेला परेन। फरक खोजी प्रयास गर्नुहोस्।",
  },
  om: {
    title: "Akkamitti si gargaaruu dandeenya?",
    queryInputPlaceholder: "Tajaajila barbaadi...",
    locationInputPlaceholder: "Bakka kee galchi...",
    noResultsFallbackText: "Bu'aan hin argamne. Barbaada biraa yaali.",
  },
  or: {
    title: "ଆମେ କିପରି ସାହାଯ୍ୟ କରିପାରିବା?",
    queryInputPlaceholder: "ସେବା ଖୋଜନ୍ତୁ...",
    locationInputPlaceholder: "ଆପଣଙ୍କର ଅବସ୍ଥାନ ପ୍ରବେଶ କରନ୍ତୁ...",
    noResultsFallbackText:
      "କୌଣସି ଫଳାଫଳ ମିଳିଲା ନାହିଁ। ଏକ ଭିନ୍ନ ସନ୍ଧାନ ଚେଷ୍ଟା କରନ୍ତୁ।",
  },
  ps: {
    title: "موږ څنګه مرسته کولی شو؟",
    queryInputPlaceholder: "د خدماتو لټون وکړئ...",
    locationInputPlaceholder: "خپل موقعیت دننه کړئ...",
    noResultsFallbackText: "هیڅ پایله ونه موندل شوه. بل لټون هڅه وکړئ.",
  },
  prs: {
    title: "چطور می‌توانیم کمک کنیم؟",
    queryInputPlaceholder: "جستجوی خدمات...",
    locationInputPlaceholder: "موقعیت خود را وارد کنید...",
    noResultsFallbackText: "هیچ نتیجه‌ای یافت نشد. جستجوی دیگری امتحان کنید.",
  },
  pt: {
    title: "Como podemos ajudar?",
    queryInputPlaceholder: "Pesquisar serviços...",
    locationInputPlaceholder: "Digite sua localização...",
    noResultsFallbackText:
      "Nenhum resultado encontrado. Tente uma pesquisa diferente.",
  },
  ru: {
    title: "Как мы можем помочь?",
    queryInputPlaceholder: "Поиск услуг...",
    locationInputPlaceholder: "Введите ваше местоположение...",
    noResultsFallbackText: "Результатов не найдено. Попробуйте другой поиск.",
  },
  so: {
    title: "Sidee ayaan kaaga caawin karnaa?",
    queryInputPlaceholder: "Raadi adeegyada...",
    locationInputPlaceholder: "Geli goobta...",
    noResultsFallbackText: "Natiijo lama helin. Isku day raadin kale.",
  },
  sw: {
    title: "Tunawezaje kusaidia?",
    queryInputPlaceholder: "Tafuta huduma...",
    locationInputPlaceholder: "Ingiza eneo lako...",
    noResultsFallbackText:
      "Hakuna matokeo yaliyopatikana. Jaribu utafutaji mwingine.",
  },
  uk: {
    title: "Як ми можемо допомогти?",
    queryInputPlaceholder: "Пошук послуг...",
    locationInputPlaceholder: "Введіть ваше місцезнаходження...",
    noResultsFallbackText: "Результатів не знайдено. Спробуйте інший пошук.",
  },
  vi: {
    title: "Chúng tôi có thể giúp gì?",
    queryInputPlaceholder: "Tìm kiếm dịch vụ...",
    locationInputPlaceholder: "Nhập vị trí của bạn...",
    noResultsFallbackText: "Không tìm thấy kết quả. Thử tìm kiếm khác.",
  },
  yue: {
    title: "我哋可以點樣幫到你?",
    queryInputPlaceholder: "搜尋服務...",
    locationInputPlaceholder: "輸入你嘅位置...",
    noResultsFallbackText: "搵唔到結果。試下其他搜尋。",
  },
  "zh-Hans": {
    title: "我们如何帮助您?",
    queryInputPlaceholder: "搜索服务...",
    locationInputPlaceholder: "输入您的位置...",
    noResultsFallbackText: "未找到结果。尝试其他搜索。",
  },
  "zh-Hant": {
    title: "我們如何幫助您?",
    queryInputPlaceholder: "搜尋服務...",
    locationInputPlaceholder: "輸入您的位置...",
    noResultsFallbackText: "未找到結果。嘗試其他搜尋。",
  },
};

export const otherTranslations: Record<Locale, OtherTranslations> = {
  en: {
    search: "Search",
    back: "Back",
    useMyLocation: "Use My Location",
    gettingLocation: "Getting location...",
    addMyLocation: "Add My Location",
    clearInput: "Clear input",
    unableToRetrieveLocation: "Unable to retrieve location",
    failedToLoadWidget: "Failed to load widget",
    unknownError: "Unknown error",
    noSuggestionsFound:
      "No suggestions found, but you can still search for anything",
  },
  pl: {
    search: "Szukaj",
    back: "Wróć",
    useMyLocation: "Użyj mojej lokalizacji",
    gettingLocation: "Pobieranie lokalizacji...",
    addMyLocation: "Dodaj moją lokalizację",
    clearInput: "Wyczyść pole",
    unableToRetrieveLocation: "Nie można pobrać lokalizacji",
    failedToLoadWidget: "Nie udało się załadować widżetu",
    unknownError: "Nieznany błąd",
    noSuggestionsFound:
      "Nie znaleziono sugestii, ale możesz wyszukać cokolwiek",
  },
  es: {
    search: "Buscar",
    back: "Volver",
    useMyLocation: "Usar mi ubicación",
    gettingLocation: "Obteniendo ubicación...",
    addMyLocation: "Agregar mi ubicación",
    clearInput: "Limpiar entrada",
    unableToRetrieveLocation: "No se puede obtener la ubicación",
    failedToLoadWidget: "Error al cargar el widget",
    unknownError: "Error desconocido",
    noSuggestionsFound:
      "No se encontraron sugerencias, pero puedes buscar cualquier cosa",
  },
  am: {
    search: "ፍለጋ",
    back: "ተመለስ",
    useMyLocation: "የእኔን አካባቢ ተጠቀም",
    gettingLocation: "አካባቢን በማግኘት ላይ...",
    addMyLocation: "የእኔን አካባቢ አክል",
    clearInput: "ግቤትን አጽዳ",
    unableToRetrieveLocation: "አካባቢን ማግኘት አልተቻለም",
    failedToLoadWidget: "ዊጀትን መጫን አልተቻለም",
    unknownError: "ያልታወቀ ስህተት",
    noSuggestionsFound: "ምንም አስተያየቶች አልተገኙም፣ ግን አሁንም ማንኛውንም ነገር መፈለግ ይችላሉ",
  },
  ar: {
    search: "بحث",
    back: "رجوع",
    useMyLocation: "استخدم موقعي",
    gettingLocation: "جارٍ الحصول على الموقع...",
    addMyLocation: "إضافة موقعي",
    clearInput: "مسح الإدخال",
    unableToRetrieveLocation: "تعذر استرداد الموقع",
    failedToLoadWidget: "فشل تحميل الأداة",
    unknownError: "خطأ غير معروف",
    noSuggestionsFound:
      "لم يتم العثور على اقتراحات، ولكن لا يزال بإمكانك البحث عن أي شيء",
  },
  de: {
    search: "Suchen",
    back: "Zurück",
    useMyLocation: "Meinen Standort verwenden",
    gettingLocation: "Standort wird abgerufen...",
    addMyLocation: "Meinen Standort hinzufügen",
    clearInput: "Eingabe löschen",
    unableToRetrieveLocation: "Standort konnte nicht abgerufen werden",
    failedToLoadWidget: "Widget konnte nicht geladen werden",
    unknownError: "Unbekannter Fehler",
    noSuggestionsFound:
      "Keine Vorschläge gefunden, aber Sie können trotzdem nach allem suchen",
  },
  fa: {
    search: "جستجو",
    back: "بازگشت",
    useMyLocation: "استفاده از موقعیت من",
    gettingLocation: "در حال دریافت موقعیت...",
    addMyLocation: "افزودن موقعیت من",
    clearInput: "پاک کردن ورودی",
    unableToRetrieveLocation: "امکان بازیابی موقعیت وجود ندارد",
    failedToLoadWidget: "بارگذاری ابزارک ناموفق بود",
    unknownError: "خطای ناشناخته",
    noSuggestionsFound:
      "پیشنهادی یافت نشد، اما همچنان می‌توانید هر چیزی را جستجو کنید",
  },
  fi: {
    search: "Haku",
    back: "Takaisin",
    useMyLocation: "Käytä sijaintiani",
    gettingLocation: "Haetaan sijaintia...",
    addMyLocation: "Lisää sijaintini",
    clearInput: "Tyhjennä kenttä",
    unableToRetrieveLocation: "Sijaintia ei voitu hakea",
    failedToLoadWidget: "Widgetin lataus epäonnistui",
    unknownError: "Tuntematon virhe",
    noSuggestionsFound:
      "Ehdotuksia ei löytynyt, mutta voit silti etsiä mitä tahansa",
  },
  fil: {
    search: "Maghanap",
    back: "Bumalik",
    useMyLocation: "Gamitin ang aking lokasyon",
    gettingLocation: "Kinukuha ang lokasyon...",
    addMyLocation: "Idagdag ang aking lokasyon",
    clearInput: "Burahin ang input",
    unableToRetrieveLocation: "Hindi makuha ang lokasyon",
    failedToLoadWidget: "Nabigong i-load ang widget",
    unknownError: "Hindi kilalang error",
    noSuggestionsFound:
      "Walang nakitang mungkahi, ngunit maaari ka pa ring maghanap ng anumang bagay",
  },
  ff: {
    search: "Yiylo",
    back: "Rutto",
    useMyLocation: "Huutoro nokkuure am",
    gettingLocation: "Heɓtingo nokkuure...",
    addMyLocation: "Ɓeydu nokkuure am",
    clearInput: "Momtu naatannde",
    unableToRetrieveLocation: "Horiima heɓde nokkuure",
    failedToLoadWidget: "Njaamaali loowde widget",
    unknownError: "Juumre anndaaka",
    noSuggestionsFound:
      "Yeewaani ɓeyditte kono aɗa waawi yiylotaade hay huunde",
  },
  fr: {
    search: "Rechercher",
    back: "Retour",
    useMyLocation: "Utiliser ma position",
    gettingLocation: "Obtention de la position...",
    addMyLocation: "Ajouter ma position",
    clearInput: "Effacer le champ",
    unableToRetrieveLocation: "Impossible de récupérer la position",
    failedToLoadWidget: "Échec du chargement du widget",
    unknownError: "Erreur inconnue",
    noSuggestionsFound:
      "Aucune suggestion trouvée, mais vous pouvez toujours rechercher n'importe quoi",
  },
  hi: {
    search: "खोजें",
    back: "वापस",
    useMyLocation: "मेरा स्थान उपयोग करें",
    gettingLocation: "स्थान प्राप्त कर रहे हैं...",
    addMyLocation: "मेरा स्थान जोड़ें",
    clearInput: "इनपुट साफ़ करें",
    unableToRetrieveLocation: "स्थान पुनर्प्राप्त करने में असमर्थ",
    failedToLoadWidget: "विजेट लोड करने में विफल",
    unknownError: "अज्ञात त्रुटि",
    noSuggestionsFound:
      "कोई सुझाव नहीं मिला, लेकिन आप अभी भी कुछ भी खोज सकते हैं",
  },
  hr: {
    search: "Traži",
    back: "Natrag",
    useMyLocation: "Koristi moju lokaciju",
    gettingLocation: "Dohvaćanje lokacije...",
    addMyLocation: "Dodaj moju lokaciju",
    clearInput: "Obriši unos",
    unableToRetrieveLocation: "Ne mogu dohvatiti lokaciju",
    failedToLoadWidget: "Učitavanje widgeta nije uspjelo",
    unknownError: "Nepoznata greška",
    noSuggestionsFound:
      "Nismo mogli pronaći upit koji se odnosi na vas, ali slobodno pretražujte po tekstu",
  },
  ht: {
    search: "Chèche",
    back: "Retounen",
    useMyLocation: "Sèvi ak kote mwen ye",
    gettingLocation: "Jwenn kote...",
    addMyLocation: "Ajoute kote mwen ye",
    clearInput: "Efase antre",
    unableToRetrieveLocation: "Pa kapab jwenn kote",
    failedToLoadWidget: "Chaje widget pa mache",
    unknownError: "Erè enkoni",
    noSuggestionsFound:
      "Nou pa t kapab jwenn yon kesyon ki gen rapò avè w men ou lib pou chèche pa tèks",
  },
  ko: {
    search: "검색",
    back: "뒤로",
    useMyLocation: "내 위치 사용",
    gettingLocation: "위치 가져오는 중...",
    addMyLocation: "내 위치 추가",
    clearInput: "입력 지우기",
    unableToRetrieveLocation: "위치를 가져올 수 없습니다",
    failedToLoadWidget: "위젯을 로드하지 못했습니다",
    unknownError: "알 수 없는 오류",
    noSuggestionsFound:
      "귀하와 관련된 쿼리를 찾을 수 없지만 텍스트로 자유롭게 검색하세요",
  },
  km: {
    search: "ស្វែងរក",
    back: "ត្រលប់ក្រោយ",
    useMyLocation: "ប្រើទីតាំងរបស់ខ្ញុំ",
    gettingLocation: "កំពុងទទួលបានទីតាំង...",
    addMyLocation: "បន្ថែមទីតាំងរបស់ខ្ញុំ",
    clearInput: "សម្អាតការបញ្ចូល",
    unableToRetrieveLocation: "មិនអាចទទួលបានទីតាំងបានទេ",
    failedToLoadWidget: "បរាជ័យក្នុងការផ្ទុក widget",
    unknownError: "កំហុសមិនស្គាល់",
    noSuggestionsFound:
      "យើងមិនអាចរកឃើញសំណួរដែលទាក់ទងនឹងអ្នកបានទេ ប៉ុន្តែសូមស្វែងរកដោយអត្ថបទដោយសេរី",
  },
  lo: {
    search: "ຄົ້ນຫາ",
    back: "ກັບຄືນ",
    useMyLocation: "ໃຊ້ສະຖານທີ່ຂອງຂ້ອຍ",
    gettingLocation: "ກຳລັງຮັບສະຖານທີ່...",
    addMyLocation: "ເພີ່ມສະຖານທີ່ຂອງຂ້ອຍ",
    clearInput: "ລ້າງຂໍ້ມູນທີ່ປ້ອນ",
    unableToRetrieveLocation: "ບໍ່ສາມາດຮັບສະຖານທີ່ໄດ້",
    failedToLoadWidget: "ໂຫລດ widget ບໍ່ສຳເລັດ",
    unknownError: "ຄວາມຜິດພາດທີ່ບໍ່ຮູ້ຈັກ",
    noSuggestionsFound:
      "ພວກເຮົາບໍ່ສາມາດຊອກຫາຄຳຖາມທີ່ກ່ຽວຂ້ອງກັບທ່ານໄດ້ແຕ່ຢ່າລັງເລທີ່ຈະຄົ້ນຫາໂດຍຂໍ້ຄວາມ",
  },
  mww: {
    search: "Nrhiav",
    back: "Rov qab",
    useMyLocation: "Siv kuv qhov chaw nyob",
    gettingLocation: "Tau txais qhov chaw nyob...",
    addMyLocation: "Ntxiv kuv qhov chaw nyob",
    clearInput: "Tshem tawm",
    unableToRetrieveLocation: "Tsis tau txais qhov chaw nyob",
    failedToLoadWidget: "Tsis thauj tau widget",
    unknownError: "Yuam kev tsis paub",
    noSuggestionsFound:
      "Peb nrhiav tsis tau ib lo lus nug txog koj tab sis koj xav nrhiav los ntawm cov ntawv",
  },
  ne: {
    search: "खोज्नुहोस्",
    back: "फिर्ता",
    useMyLocation: "मेरो स्थान प्रयोग गर्नुहोस्",
    gettingLocation: "स्थान प्राप्त गर्दै...",
    addMyLocation: "मेरो स्थान थप्नुहोस्",
    clearInput: "इनपुट खाली गर्नुहोस्",
    unableToRetrieveLocation: "स्थान पुन: प्राप्त गर्न असमर्थ",
    failedToLoadWidget: "विजेट लोड गर्न असफल भयो",
    unknownError: "अज्ञात त्रुटि",
    noSuggestionsFound:
      "हामीले तपाईंसँग सम्बन्धित कुनै क्वेरी फेला पार्न सकेनौं तर पाठद्वारा खोजी गर्न स्वतन्त्र महसुस गर्नुहोस्",
  },
  om: {
    search: "Barbaadi",
    back: "Deebi'i",
    useMyLocation: "Bakka koo fayyadami",
    gettingLocation: "Bakka argachuu...",
    addMyLocation: "Bakka koo ida'i",
    clearInput: "Galmee haqii",
    unableToRetrieveLocation: "Bakka argachuu hin danda'amne",
    failedToLoadWidget: "Widget fe'uun dhabame",
    unknownError: "Dogongora hin beekamne",
    noSuggestionsFound:
      "Gaaffii si wajjin walqabatu argachuu hin dandeenye garuu barreeffamaan barbaaduu bilisaan",
  },
  or: {
    search: "ଖୋଜନ୍ତୁ",
    back: "ପଛକୁ",
    useMyLocation: "ମୋ ଅବସ୍ଥାନ ବ୍ୟବହାର କରନ୍ତୁ",
    gettingLocation: "ଅବସ୍ଥାନ ପାଇବା...",
    addMyLocation: "ମୋ ଅବସ୍ଥାନ ଯୋଡନ୍ତୁ",
    clearInput: "ଇନପୁଟ୍ ସଫା କରନ୍ତୁ",
    unableToRetrieveLocation: "ଅବସ୍ଥାନ ପୁନରୁଦ୍ଧାର କରିବାରେ ଅସମର୍ଥ",
    failedToLoadWidget: "ୱିଜେଟ୍ ଲୋଡ୍ କରିବାରେ ବିଫଳ",
    unknownError: "ଅଜଣା ତ୍ରୁଟି",
    noSuggestionsFound:
      "ଆମେ ଆପଣଙ୍କ ସହିତ ସମ୍ବନ୍ଧିତ କୌଣସି କ୍ୱେରୀ ଖୋଜି ପାରିଲୁ ନାହିଁ କିନ୍ତୁ ପାଠ୍ୟ ଦ୍ୱାରା ସନ୍ଧାନ କରିବାକୁ ମୁକ୍ତ ଅନୁଭବ କରନ୍ତୁ",
  },
  ps: {
    search: "لټون",
    back: "شاته",
    useMyLocation: "زما موقعیت وکاروئ",
    gettingLocation: "موقعیت ترلاسه کول...",
    addMyLocation: "زما موقعیت اضافه کړئ",
    clearInput: "ان پټ پاک کړئ",
    unableToRetrieveLocation: "موقعیت بیرته ترلاسه کولو کې ناکام",
    failedToLoadWidget: "د ویجټ بارولو کې ناکامي",
    unknownError: "ناپېژندلې تېروتنه",
    noSuggestionsFound:
      "موږ ستاسو سره تړلې پوښتنه ونه موندله مګر د متن له لارې لټون وکړئ",
  },
  prs: {
    search: "جستجو",
    back: "بازگشت",
    useMyLocation: "از موقعیت من استفاده کنید",
    gettingLocation: "دریافت موقعیت...",
    addMyLocation: "موقعیت من را اضافه کنید",
    clearInput: "پاک کردن ورودی",
    unableToRetrieveLocation: "امکان بازیابی موقعیت وجود ندارد",
    failedToLoadWidget: "بارگذاری ابزارک ناموفق بود",
    unknownError: "خطای ناشناخته",
    noSuggestionsFound:
      "ما نتوانستیم پرس و جویی مرتبط با شما پیدا کنیم اما با خیال راحت با متن جستجو کنید",
  },
  pt: {
    search: "Pesquisar",
    back: "Voltar",
    useMyLocation: "Usar minha localização",
    gettingLocation: "Obtendo localização...",
    addMyLocation: "Adicionar minha localização",
    clearInput: "Limpar entrada",
    unableToRetrieveLocation: "Não foi possível recuperar a localização",
    failedToLoadWidget: "Falha ao carregar o widget",
    unknownError: "Erro desconhecido",
    noSuggestionsFound:
      "Não conseguimos encontrar uma consulta relacionada a você, mas fique à vontade para pesquisar por texto",
  },
  ru: {
    search: "Поиск",
    back: "Назад",
    useMyLocation: "Использовать мое местоположение",
    gettingLocation: "Получение местоположения...",
    addMyLocation: "Добавить мое местоположение",
    clearInput: "Очистить ввод",
    unableToRetrieveLocation: "Не удалось получить местоположение",
    failedToLoadWidget: "Не удалось загрузить виджет",
    unknownError: "Неизвестная ошибка",
    noSuggestionsFound:
      "Мы не смогли найти запрос, связанный с вами, но вы можете выполнить поиск по тексту",
  },
  so: {
    search: "Raadi",
    back: "Dib u noqo",
    useMyLocation: "Isticmaal goobta",
    gettingLocation: "Helitaanka goobta...",
    addMyLocation: "Ku dar goobta",
    clearInput: "Nadiifi",
    unableToRetrieveLocation: "Lama heli karo goobta",
    failedToLoadWidget: "Ku guuldarraysatay soo dejinta widget-ka",
    unknownError: "Khalad aan la garanayn",
    noSuggestionsFound:
      "Ma heli karno su'aal kula xidhiidha laakiin si xor ah u raadi qoraalka",
  },
  sw: {
    search: "Tafuta",
    back: "Rudi",
    useMyLocation: "Tumia eneo langu",
    gettingLocation: "Inapata eneo...",
    addMyLocation: "Ongeza eneo langu",
    clearInput: "Futa ingizo",
    unableToRetrieveLocation: "Haiwezi kupata eneo",
    failedToLoadWidget: "Imeshindwa kupakia widget",
    unknownError: "Kosa lisilojulikana",
    noSuggestionsFound:
      "Hatukuweza kupata swali linalohusiana nawe lakini jisikie huru kutafuta kwa maandishi",
  },
  uk: {
    search: "Пошук",
    back: "Назад",
    useMyLocation: "Використати моє місцезнаходження",
    gettingLocation: "Отримання місцезнаходження...",
    addMyLocation: "Додати моє місцезнаходження",
    clearInput: "Очистити введення",
    unableToRetrieveLocation: "Не вдалося отримати місцезнаходження",
    failedToLoadWidget: "Не вдалося завантажити віджет",
    unknownError: "Невідома помилка",
    noSuggestionsFound:
      "Ми не змогли знайти запит, пов'язаний з вами, але ви можете шукати за текстом",
  },
  vi: {
    search: "Tìm kiếm",
    back: "Quay lại",
    useMyLocation: "Sử dụng vị trí của tôi",
    gettingLocation: "Đang lấy vị trí...",
    addMyLocation: "Thêm vị trí của tôi",
    clearInput: "Xóa nhập liệu",
    unableToRetrieveLocation: "Không thể lấy vị trí",
    failedToLoadWidget: "Không tải được widget",
    unknownError: "Lỗi không xác định",
    noSuggestionsFound:
      "Chúng tôi không thể tìm thấy truy vấn liên quan đến bạn nhưng hãy thoải mái tìm kiếm theo văn bản",
  },
  yue: {
    search: "搜尋",
    back: "返回",
    useMyLocation: "使用我嘅位置",
    gettingLocation: "獲取位置中...",
    addMyLocation: "加入我嘅位置",
    clearInput: "清除輸入",
    unableToRetrieveLocation: "無法獲取位置",
    failedToLoadWidget: "無法載入小工具",
    unknownError: "未知錯誤",
    noSuggestionsFound: "我哋搵唔到同你相關嘅查詢，但你可以隨意用文字搜尋",
  },
  "zh-Hans": {
    search: "搜索",
    back: "返回",
    useMyLocation: "使用我的位置",
    gettingLocation: "获取位置中...",
    addMyLocation: "添加我的位置",
    clearInput: "清除输入",
    unableToRetrieveLocation: "无法获取位置",
    failedToLoadWidget: "无法加载小部件",
    unknownError: "未知错误",
    noSuggestionsFound: "我们找不到与您相关的查询，但请随意按文本搜索",
  },
  "zh-Hant": {
    search: "搜尋",
    back: "返回",
    useMyLocation: "使用我的位置",
    gettingLocation: "獲取位置中...",
    addMyLocation: "新增我的位置",
    clearInput: "清除輸入",
    unableToRetrieveLocation: "無法獲取位置",
    failedToLoadWidget: "無法載入小工具",
    unknownError: "未知錯誤",
    noSuggestionsFound: "我們找不到與您相關的查詢，但請隨意按文字搜尋",
  },
};
